import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Select,
  MenuItem,
  Button,
  Stack,
} from "@mui/material";
import { translate } from "../../utils/localisation";
import { PracticeLocation } from "../../utils/kinshipTypes";

interface Props {
  clinics: PracticeLocation[];
  selectedClinic: string;
  onChangeClinic: (id: string) => void;
  onGetSummary: (e: React.MouseEvent) => void;
  loading: boolean;
}

export default function GetClinicSummary({
  clinics,
  selectedClinic,
  onChangeClinic,
  onGetSummary,
  loading,
}: Props) {
  return (
    <Box sx={{ mt: 2, p: 4, border: 1, borderColor: "gray", borderRadius: 2 }}>
      <Typography variant="h4" gutterBottom>
        {translate(
          "clinic-summary-screen.getSummarySection.dropdown-label-text"
        )}
      </Typography>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>
              <Select
                fullWidth
                displayEmpty
                value={selectedClinic}
                onChange={e => onChangeClinic(e.target.value as string)}
                disabled={loading}
                sx={{ minWidth: 200 }}
              >
                <MenuItem value="">
                  {translate(
                    "clinic-summary-screen.getSummarySection.dropdown-label-text"
                  )}
                </MenuItem>
                {clinics.map(c => (
                  <MenuItem key={c.kinshipId} value={c.vetstoriaClinicHash}>
                    {c.name}
                  </MenuItem>
                ))}
              </Select>
            </TableCell>
            <TableCell align="right">
              <Stack direction="row" spacing={1}>
                <Button
                  variant="contained"
                  onClick={onGetSummary}
                  disabled={loading || !selectedClinic}
                >
                  {translate(
                    "clinic-summary-screen.getSummarySection.GetSummary"
                  )}
                </Button>
              </Stack>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
}
